import { TherapistAction } from 'src/redux/actions/constant';

const intialState: object = {
  response: null,
  data: [],
  loading: false,
  isTimeEdited: false,
  suppressSuccessMessage: false,
};

export const editTaskTimeReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.EDIT_TASK_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        data: action.payload.data,
        loading: false,
        isTimeEdited: true,
        isAssigned: action?.isAssigned,
        suppressSuccessMessage: action?.suppressSuccessMessage || false,
      };
    }
    case TherapistAction.EDIT_TASK_FAILURE: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTimeEdited: false,
        requestPayload: action.requestPayload,
      };
    }
    case TherapistAction.EDIT_TASK_REQUEST:
      return {
        ...state,
        loading: true,
        isTimeEdited: false,
      };

    case TherapistAction.EDIT_TASK_RESET:
      return intialState;

    default:
      return state;
  }
};
